import { useEffect, useState, useRef, useContext } from 'react';
import Map from '../Map';
import secureLocalStorage from 'react-secure-storage';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { MyContext } from '../../Context/MyProvider';
import BtnLoader from '../BtnLoader';
import { useTranslation } from 'react-i18next';
const CompletedModel = ({ pageData, setShowModel, showModel }) => {
    const { t } = useTranslation();

    const { BaseUrl, handleCallApi } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [pickupLocation, setPickupLocation] = useState(null);
    const [dropLocation, setDropLocation] = useState(null);
    const [locationsList, setLocationsList] = useState([]);
    const [stopList, setStopList] = useState([]);

    const FetchRef = useRef(false);

    const currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        handleGetData();
    }, []);

    const handleGetData = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/all_ride_detail", { uid, request_id: pageData?.id, status: showModel === "completed" ? "complete" : "cancel" });
        const ReqData = Response.data.Reuqest_list;
        if (ReqData) {
            setData(ReqData);
            setPickupLocation({
                ...ReqData?.pickup,
                lat: Number(ReqData?.pickup?.latitude),
                lng: Number(ReqData?.pickup?.longitude)
            });

            const drops = Array.isArray(ReqData?.drop) ? ReqData.drop : (ReqData?.drop ? [ReqData.drop] : []);
            
            if (drops.length > 0) {
                const finalDrop = drops[drops.length - 1];
                setDropLocation({
                    ...finalDrop,
                    lat: Number(finalDrop?.latitude),
                    lng: Number(finalDrop?.longitude)
                });
                
                const stops = drops.slice(0, -1);
                setStopList(stops.map(item => ({
                    lat: Number(item.latitude),
                    lng: Number(item.longitude)
                })));

                const pickupStop = { type: "pickup", title: ReqData?.pickup?.title || "", subtitle: ReqData?.pickup?.subtitle || "", colorClass: "location-icon-green", textClass: "text-green-600", label: t("PICKUP") };
                const intermediateStops = stops.map((stop, idx) => ({
                    type: "stop",
                    title: stop?.title || "",
                    subtitle: stop?.subtitle || "",
                    colorClass: "location-icon-yellow",
                    textClass: "text-yellow-600",
                    label: `${t("STOP")} ${idx + 1}`
                }));
                const finalDestination = {
                    type: "drop",
                    title: finalDrop?.title || "",
                    subtitle: finalDrop?.subtitle || "",
                    colorClass: "location-icon-red",
                    textClass: "text-red-600",
                    label: t("DESTINATION")
                };
                setLocationsList([pickupStop, ...intermediateStops, finalDestination]);
            } else {
                setDropLocation(null);
                setStopList([]);
                setLocationsList([
                    { type: "pickup", title: ReqData?.pickup?.title || "", subtitle: ReqData?.pickup?.subtitle || "", colorClass: "location-icon-green", textClass: "text-green-600", label: t("PICKUP") }
                ]);
            }
        }
        setLoading(false);
    }


    const downloadInvoice = () => {

        const doc = new jsPDF();

        // Header Title
        doc.setFontSize(22);
        doc.setTextColor(64, 56, 255);
        doc.text("ZippyGo", 14, 20);
        doc.setFontSize(11);
        doc.setTextColor(128, 128, 128);
        doc.text("Ride Receipt", 14, 26);

        // Booking Info
        doc.setFontSize(10);
        doc.setTextColor(50, 50, 50);
        doc.text(`Booking ID: #${data?.id}`, 14, 36);
        doc.text(`Date & Time: ${data?.start_time}`, 14, 42);
        doc.text(`Ride Category: ${data?.mode_title}`, 14, 48);

        // Driver & Vehicle Details
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text("Captain & Vehicle Details", 14, 58);
        doc.setFontSize(10);
        doc.setTextColor(80, 80, 80);
        const captainName = data?.first_name ? `${data.first_name} ${data.last_name}` : "N/A";
        doc.text(`Captain Name: ${captainName}`, 14, 64);
        doc.text(`Captain Phone: ${data?.driver_phone || "N/A"}`, 14, 70);
        doc.text(`Vehicle Model: ${data?.vehicle_name || "N/A"}`, 14, 76);
        doc.text(`Payment Method: ${data?.p_name || "N/A"}`, 14, 82);

        // Route details
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text("Route Info", 14, 92);
        doc.setFontSize(10);
        doc.setTextColor(80, 80, 80);
        doc.text(`Pickup: ${data?.pickup?.title || "N/A"}`, 14, 98);

        const dropsArray = Array.isArray(data?.drop) ? data.drop : (data?.drop ? [data.drop] : []);
        let startY = 104;
        
        if (dropsArray.length > 0) {
            const finalDestination = dropsArray[dropsArray.length - 1];
            doc.text(`Dropoff: ${finalDestination?.title || "N/A"}`, 14, startY);
            startY += 6;
            
            if (dropsArray.length > 1) {
                doc.text("Stops List:", 14, startY);
                dropsArray.slice(0, -1).forEach((stop, index) => {
                    doc.text(`• Stop ${index + 1}: ${stop.title || "N/A"}`, 18, startY + (index + 1) * 6);
                });
                startY += (dropsArray.length) * 6;
            }
        } else {
            doc.text("Dropoff: N/A", 14, startY);
            startY += 6;
        }

        // Fare Breakdown
        const body = [
            ["Platform Fee", currency + data?.platform_fee],
            ["KM Charge", currency + data?.km_charge],
            ["Extra Charge", currency + data?.extra_charge],
        ];

        if (data?.addi_time_price !== 0) {
            body.push([
                `Additional Wait Time Charge (${data?.addi_time} Min)`,
                currency + data?.addi_time_price
            ]);
        }

        if (data?.bid_addjust_amount) {
            body.push([
                "Adjusted Bid Price",
                currency + data?.bid_addjust_amount
            ]);
        }

        body.push([
            "Final Total Paid",
            currency + data?.final_price
        ]);

        autoTable(doc, {
            startY: startY + 10,
            head: [["Charge Description", "Amount"]],
            body: body,
            theme: "grid",
            headStyles: { fillColor: [64, 56, 255] }
        });

        doc.save(`ZippyGo-Receipt-#${data?.id}.pdf`);
    };

    if (loading) {
        return <div className="h-[calc(100vh-40px)]">
            <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
        </div>
    }

    return (
        <>

            {!loading && <div>

                <div className="px-4 py-2 flex items-center justify-between">
                    <h1 className="font-semibold">{t("Booking id")} : #{data?.id}</h1>
                    <button onClick={() => setShowModel("")}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                        </svg>
                    </button>
                </div>

                <div className="w-full h-[400px]">
                    <Map pickupLocation={pickupLocation} dropLocation={dropLocation} step={null} categoryData={[]} HandleGetGoogleAddress={null} stopList={stopList} />
                </div>

                <div>
                    <div className="w-full h-[5px] bg-gray-200"></div>

                    <div className="py-2 px-5 space-y-2">
                        {locationsList.map((stop, idx) => (
                            <div key={idx} className="flex gap-3">
                                <div className="flex flex-col items-center pt-1.5 w-5 flex-shrink-0 relative">
                                    <div className={stop.colorClass}></div>
                                    {idx !== locationsList.length - 1 && (
                                        <div className="absolute w-0.5 border-l-2 border-dashed border-gray-400 z-0" style={{ top: "16px", bottom: "-24px" }}></div>
                                    )}
                                </div>
                                <div className="flex-1 pb-1">
                                    <h1 className={`text-[11px] font-bold leading-none ${stop.textClass}`}>{stop.label}</h1>
                                    <p className="text-[14px] font-medium text-gray-800 line-clamp-1 mt-1">
                                        {stop.title}
                                    </p>
                                    {stop.subtitle && (
                                        <p className="text-[13px] text-gray-500 line-clamp-2 mt-0.5">{stop.subtitle}</p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="w-full h-[5px] bg-gray-200"></div>

                    <div className="py-2 px-5">
                        <h1 className="font-semibold uppercase">{t("Ride Details")}</h1>
                        <div className="py-2">
                            <div className="flex items-center justify-between">
                                <h1>{t("Ride Type")} :</h1>
                                <span>{data?.mode_title}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Car Type")} :</h1>
                                <span>{data?.vehicle_name}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Hours & Minites")} :</h1>
                                <span>{data?.tot_hour} {t("Hours")} {data?.tot_minute} {t("Minites")}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Date & Time")} :</h1>
                                <span>{data?.start_time}</span>
                            </div>
                        </div>
                    </div>

                    <div className="w-full h-[5px] bg-gray-200"></div>

                    <div className="py-2 px-5">
                        <h1 className="font-semibold uppercase">{t("Captain Details")}</h1>
                        <div className="py-2">
                            <div className="flex items-center justify-between">
                                <h1>{t("Captain Name")} :</h1>
                                <span>{data?.first_name ? `${data.first_name} ${data.last_name}` : "N/A"}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Captain Phone")} :</h1>
                                <span>{data?.driver_phone || "N/A"}</span>
                            </div>
                        </div>
                    </div>

                    <div className="w-full h-[5px] bg-gray-200"></div>

                    <div className="py-2 px-5">
                        <h1 className="font-semibold uppercase">{t("Payment Details")}</h1>
                        <div className="py-2">
                            <div className="flex items-center justify-between">
                                <h1>{t("Payment Method")} :</h1>
                                <span>{data?.p_name || "N/A"}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Platform Fee")} :</h1>
                                <span>{currency + Number(data?.platform_fee || 0).toFixed(2)}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Km Charge")} :</h1>
                                <span>{currency + Number(data?.km_charge || 0).toFixed(2)}</span>
                            </div>
                            {(data?.addi_time !== 0 && data?.addi_time_price !== 0) && <div className="flex items-center justify-between">
                                <h1>{t("Additional Time Charge")} ({data?.addi_time} {t("Minutes")}) :</h1>
                                <span>{currency + Number(data?.addi_time_price || 0).toFixed(2)}</span>
                            </div>}
                            {data?.bid_addjust_amount && <div className="flex items-center justify-between">
                                <h1>{t("Bid amount")} :</h1>
                                <span>{currency + data?.bid_addjust_amount}</span>
                            </div>}
                            <div className="flex items-center justify-between">
                                <h1>{t("Extra Charge")} :</h1>
                                <span>{currency + Number(data?.extra_charge || 0).toFixed(2)}</span>
                            </div>
                            <div className="flex items-center justify-between">
                                <h1>{t("Total")} :</h1>
                                <span>{currency + Number(data?.final_price || 0).toFixed(2)}</span>
                            </div>
                            {(data?.payment_id == "10" || data?.payment_id == "11") && (
                                <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-100">
                                    <h1>{t("Payment Proof")} :</h1>
                                    {data?.payment_img ? (
                                        <a href={BaseUrl + data.payment_img} target="_blank" rel="noreferrer" className="text-[14px] font-bold text-blue-600 hover:underline">
                                            {t("View Receipt Image")}
                                        </a>
                                    ) : (
                                        <span className="text-[14px] text-red-500 font-medium">{t("No Receipt Uploaded")}</span>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>

                {showModel === "completed" && <div className="flex items-center gap-4 px-4 py-2">
                    <button onClick={downloadInvoice} className="w-full h-10 bg-[--bg-color] text-white rounded-[8px] font-bold italic tracking-[1px] hover:bg-[--bg-color-hover] transition-colors">
                        {t("Invoice")}
                    </button>
                    {data?.review_check === 0 && <button onClick={() => setShowModel("Review")} className="w-full h-10 bg-orange-500 text-white rounded-[8px] font-bold italic tracking-[1px] hover:bg-orange-400 transition-colors">
                        {t("Rate your ride")}
                    </button>}
                </div>}

            </div>}

        </>
    )
}

export default CompletedModel